import React from "react";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainPage from "../../MainPage";
import {
  apiCallback,
  statusChangeApiCallback,
} from "../../../ApiHandlers/Common";
import ListGroupConfig from "./ListGroupConfig";
import GroupConfigForm from "./GroupConfigForm";
import { EntityStatus, NavMenuItems } from "../../../Constants/Constants";
import { convertGroupConfigList } from "../../../Helpers/ConfigHelpers";
import { convertGroupListToDropdown } from "../../../Helpers/GroupHelpers";
import { convertServiceProviderListToDropdown } from "../../../Helpers/ServiceProviderHelpers";

class GroupConfig extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.configuration.icon()}
        <span>{NavMenuItems.configuration.group.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      providerData: [],
      providerDataLoading: false,
      selectedProvider: null,
      groupData: [],
      groupDataLoading: false,
      selectedGroup: null,
      groupConfigData: [],
      groupConfigDataLoading: false,
      deleteConfigDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateProviderList();
  }

  updateProviderList = () => {
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ providerDataLoading: false });
      message.error("Error fetching Service Provider list");
    };
    const successCallback = (data) => {
      const providerData = convertServiceProviderListToDropdown(data);
      console.log("updateData data", providerData);
      this.setState({ providerData, providerDataLoading: false });
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  updateGroupList = (id) => {
    const providerId = id || this.state.selectedProvider;
    if (!providerId) return;
    const { history, groupApi } = this.props;
    this.setState({ groupDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ groupDataLoading: false });
      message.error("Error fetching Group list");
    };
    const successCallback = (data) => {
      const groupData = convertGroupListToDropdown(data);
      console.log("updateData data", groupData);
      this.setState({ groupData, groupDataLoading: false });
    };
    try {
      groupApi.getGroupsByProviderId(
        providerId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  updateGroupConfigList = (id) => {
    const groupId = id || this.state.selectedGroup;
    if (!groupId) return;
    const { history, configManagementApi } = this.props;
    this.setState({ groupConfigDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ groupConfigDataLoading: false });
      message.error("Error fetching Group Config list");
    };
    const successCallback = (data) => {
      const groupConfigData = convertGroupConfigList(data);
      console.log("updateData data", groupConfigData);
      this.setState({ groupConfigData, groupConfigDataLoading: false });
    };
    try {
      configManagementApi.getConfigByGroupId(
        groupId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  deleteGroupConfig = (record) => {
    const { history, configManagementApi } = this.props;
    const errorCallback = (error) => {
      this.setState({ deleteConfigDataLoading: false });
      console.log("Error deleting config", error);
      message.error("Unable to delete");
    };
    const successCallback = (data) => {
      this.setState({ deleteConfigDataLoading: false });
      message.success("Config Deleted Successfully");
      this.updateGroupConfigList();
    };
    try {
      this.setState({ deleteConfigDataLoading: true });
      const config = {
        config: record.config,
        providerid: record.providerId,
        groupid: record.groupId,
      };
      configManagementApi.removeGroupConfig(
        config,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  onProviderSelect = (id) => {
    this.setState({
      selectedProvider: id,
      selectedGroup: null,
      groupConfigData: [],
    });
    id && this.updateGroupList(id);
  };

  onGroupSelect = (id) => {
    this.setState({ selectedGroup: id });
    id && this.updateGroupConfigList(id);
  };

  onActionClick = (action, record) => () => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateGroupConfigList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record, !status),
      });
      this.props.configManagementApi.statusUpdateGroupConfig(
        record.providerId,
        record.serviceId,
        record.deviceModelId,
        record.groupId,
        { status: status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE },
        callback
      );
      this.changeStatus(record, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  changeStatus = (record, status) => {
    try {
      const { configId } = record;
      const groupConfigData = [...this.state.groupConfigData];
      groupConfigData.forEach((item) => {
        if (item.configId === configId) {
          item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
        }
      });
      this.setState({ groupConfigData });
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  render() {
    const {
      action,
      record,
      providerData,
      providerDataLoading,
      selectedProvider,
      groupData,
      groupDataLoading,
      selectedGroup,
      groupConfigData,
      deleteConfigLoading,
      groupConfigDataLoading,
    } = this.state;
    return (
      <MainPage>
        <div className="group-config-container">
          {!action ? (
            <ListGroupConfig
              providerData={providerData}
              providerDataLoading={providerDataLoading}
              selectedProvider={selectedProvider}
              groupData={groupData}
              groupDataLoading={groupDataLoading}
              deleteConfigLoading={deleteConfigLoading}
              selectedGroup={selectedGroup}
              groupConfigData={groupConfigData}
              groupConfigDataLoading={groupConfigDataLoading}
              onProviderSelect={this.onProviderSelect}
              onGroupSelect={this.onGroupSelect}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              deleteGroupConfig={this.deleteGroupConfig}
              parentBread={this.header}
            />
          ) : (
            <GroupConfigForm
              action={action}
              record={record}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              providerData={providerData}
              providerDataLoading={providerDataLoading}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

GroupConfig.propTypes = {
  groupApi: PropTypes.object,
  serviceProviderApi: PropTypes.object,
  configManagementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  groupApi: state.apis.groupApi,
  serviceProviderApi: state.apis.serviceProviderApi,
  configManagementApi: state.apis.configManagementApi,
});
const connectedGroupConfig = connect(mapStateToProps)(GroupConfig);
export default withRouter(connectedGroupConfig);
